import { Component, Inject, PLATFORM_ID, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import type { Profile } from '@core/types';

// Consts
import { USER_ROLE } from '@consts/consts';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute,
    private title: Title,
  ) {}

  ngOnInit(): void {
    this.setDefaultTitle();
  }

  private setDefaultTitle(): void {
    const user: Profile = this.route.snapshot.data?.user;

    if (!user) { return; }

    const title: string = user.role === USER_ROLE.agent ? 'Home Equity Report' : 'Explore Refinance Options';

    this.title.setTitle(title);
  }

}
